import http from "../http-common";

class ExpenseService {
  create(data) {
    return http.post("/expenses", data);
  }

  getAll() {
    return http.get("/expenses");
  }

  getByMonth(month) {
    return http.get(`/expenses/month/${month}`);
  }

  getByYearAndMonthAndFamily(year, month, familyId) {
    return http.get(`/expenses/year/${year}/month/${month}/family/${familyId}`);
  }

  delete(id) {
    return http.delete(`/expenses/${id}`);
  }

  update(id, data) {
    return http.put(`/expenses/${id}`, data);
  }

}

export default new ExpenseService();
